import { call, put, delay } from "redux-saga/effects";
import { audioLanguageApi } from "@services/api";
import { getAllAudioLanguageActions } from "../slices";

function* getAllAudioLanguageWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllAudioLanguageActions.pending());
    const response = yield call(audioLanguageApi.getAllAudioLanguage, payload);
    yield put(getAllAudioLanguageActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllAudioLanguageActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllAudioLanguageWorker };
